import { render } from "./Customer.vue?vue&type=template&id=2760fb86"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=2760fb86&lang=css"
script.render = render

export default script